import type { ReactNode } from "react";
import { cn } from "@project/ui";

/**
 * Fondo y contenedor centrado alineado a login_web_version / registro Stitch.
 */
export function AuthCenterLayout({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div
      className={cn(
        "relative flex min-h-screen items-center justify-center overflow-hidden bg-surface px-6 py-10 font-body text-on-surface antialiased",
        className
      )}
    >
      <div
        className="pointer-events-none absolute -right-[5%] -top-[10%] h-[40rem] w-[40rem] rounded-full bg-primary/5 blur-[120px]"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-[10%] -left-[5%] h-[35rem] w-[35rem] rounded-full bg-secondary/5 blur-[100px]"
        aria-hidden
      />
      {children}
    </div>
  );
}
